import { UseConsentFormsStatus } from '@hb/react'
import {
  Form,
  getCallInForm,
  getInsuranceCallInComplete,
  PopulatedAssessment,
  PopulatedUser,
  ServerTimestamp,
} from '@hb/shared'
import { useMemo } from 'react'
import { useConsentFormsStatus } from '../../consentForms/useConsentFormsStatus'

export interface UseSignOnComplete {
  signOnStagesComplete: boolean
  signOnFormComplete: boolean
  insuranceCallInComplete: boolean
  insuranceCallInForm: Form | null
  assessmentConsentFormsComplete: boolean
  consentFormsStatus: UseConsentFormsStatus
  insuranceCallInSubmittedOn: ServerTimestamp | null
}

export const useSignOnComplete = (
  user: PopulatedUser | null,
  assessment: PopulatedAssessment | null,
): UseSignOnComplete => {
  const consentFormsStatus = useConsentFormsStatus(user?.id ?? null, user, assessment)
  const { complete: assessmentConsentFormsComplete } = consentFormsStatus

  const insuranceCallInForm = useMemo(() => getCallInForm(false, assessment), [assessment])

  const insuranceCallInComplete = useMemo(
    () => (assessment ? getInsuranceCallInComplete(assessment) : false),
    [assessment],
  )

  const signOnFormComplete = useMemo(() => !!assessment?.signedOnDate, [assessment])

  const signOnStagesComplete = useMemo(
    () => assessmentConsentFormsComplete && signOnFormComplete,
    [assessmentConsentFormsComplete, signOnFormComplete],
  )

  return {
    consentFormsStatus,
    signOnStagesComplete,
    signOnFormComplete,
    insuranceCallInComplete,
    insuranceCallInForm,
    insuranceCallInSubmittedOn: assessment?.insurerCallInSubmittedOn ?? null,
    assessmentConsentFormsComplete,
  }
}
